import Icon from "../../../components/ui/Icon";

export default function FirmwareUpdatesPage({ updateEntries, onStartNodeUpdate, onViewChangelog }) {
  if (updateEntries.length === 0) {
    return (
      <div className="flex flex-col items-center gap-4 rounded-3xl border border-brand-navy bg-brand-navy px-4 py-14 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-purple text-emerald-400">
          <Icon name="check_circle" className="text-3xl" />
        </span>
        <div className="space-y-1">
          <p className="text-base font-semibold text-brand-light">All devices up to date</p>
          <p className="text-sm text-brand-light/50">No firmware updates are currently available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {updateEntries.map((entry) => (
        <section
          key={entry.nodeId}
          className="rounded-2xl border border-brand-navy bg-brand-purple px-4 py-3 space-y-3"
        >
          <div className="flex items-start justify-between">
            <div className="flex flex-col gap-1">
              <span className="text-sm font-semibold text-brand-light">{entry.nodeName}</span>
              <div className="text-xs text-brand-light/50 flex flex-col gap-1">
                <div className="flex items-center justify-between gap-4">
                  <span>Current Version</span>
                  <span className="text-brand-light font-semibold">{entry.currentVersion}</span>
                </div>
                <div className="flex items-center justify-between gap-4">
                  <span>Available Version</span>
                  <span className="text-brand-magenta font-semibold">{entry.availableVersion}</span>
                </div>
              </div>
            </div>
            <span className="inline-flex items-center rounded-full bg-[#3a1558] text-brand-magenta text-[11px] font-semibold px-3 py-1 border border-brand-magenta/50">
              Update Available
            </span>
          </div>
          <button
            type="button"
            onClick={() => onViewChangelog(entry.nodeId)}
            className="w-full flex items-center justify-between text-sm text-brand-magenta hover:text-brand-pink transition"
          >
            <span>View Changelog</span>
            <span className="text-lg">›</span>
          </button>
          <button
            type="button"
            onClick={() => onStartNodeUpdate(entry.nodeId)}
            className="w-full rounded-xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition"
          >
            Update Node
          </button>
        </section>
      ))}
    </div>
  );
}
